export const TERMS = {
  title: "Terms of Service",
  lastUpdated: "03/11/2026",
  intro: 'These Terms of Service ("Terms") govern your access to and use of the games, websites, and related services (collectively, the "Services") published by mutopi ("mutopi," "we," "us," or "our"), an independent game studio. This includes, without limitation, our games Ruanica and Grimtile, and any future games we release. By accessing or using our Services, you agree to be bound by these Terms.',
  sections: [
    {
      heading: "1. Acceptance of Terms",
      blocks: [
        { type: 'paragraph', text: 'By downloading, installing, accessing, or using any mutopi game or visiting mutopi.com (the "Site"), you confirm that you accept these Terms and agree to comply with them. If you do not agree, please do not use our Services.' },
      ],
    },
    {
      heading: "2. Eligibility",
      blocks: [
        { type: 'paragraph', text: "The minimum age to use our Services without parental involvement varies by region — for example, 13 in the United States, 16 in the European Economic Area (or the lower age set by your specific EEA member state, where applicable), and other ages as required by local law. If you are below the applicable minimum age for your region, you may only use our Services with the involvement and verifiable consent of a parent or legal guardian, and you must otherwise be old enough to form a binding contract under the laws of your jurisdiction." },
      ],
    },
    {
      heading: "3. Our Games",
      blocks: [
        { type: 'paragraph', text: "mutopi develops and publishes multiple independent games, each with its own gameplay, features, and release status:" },
        {
          type: 'list', items: [
            { label: "Ruanica", text: "is currently under development and not yet publicly released. Features, artwork, storylines, and release dates described on our Site or communications are subject to change without notice." },
            { label: "Grimtile", text: "is available on the App Store and Google Play. It does not require any device permissions and does not collect personal data; it offers optional, anonymous gameplay analytics and downloads game configuration from our servers (see our Privacy Policy for details). We may adjust Grimtile's game balance, in-game news, and other content through these downloads at any time without releasing an app update. Any change to what data Grimtile collects will be disclosed at that time." },
          ],
        },
        { type: 'paragraph', text: "Availability, content, and functionality of any game may change, be updated, suspended, or discontinued at any time, with or without notice." },
      ],
    },
    {
      heading: "4. Beta and Pre-Release Content",
      blocks: [
        { type: 'paragraph', text: "Ruanica, and any other game or feature we label as a beta, preview, or early access, is provided for testing and feedback purposes. Beta content may be incomplete, may contain bugs, may not reflect the final product, and may be changed, reset, or discontinued at any time without notice or liability to you. Progress, content, or data associated with a beta (including any Explore map data) is not guaranteed to carry over to a full release." },
      ],
    },
    {
      heading: "5. Accounts, Waitlists, and Communities",
      blocks: [
        { type: 'paragraph', text: "Some Services may allow you to join a waitlist, mailing list, or community channel (e.g. Discord, Twitch) to receive updates. You are responsible for providing accurate contact information and for any activity associated with your accounts on third-party platforms we use to communicate with our community." },
      ],
    },
    {
      heading: "6. Location-Based Features",
      blocks: [
        { type: 'paragraph', text: "Ruanica's Explore feature relies on the accuracy of the location information your device provides. You agree not to falsify, spoof, or otherwise manipulate your device's reported location, or use third-party tools to do so, in a way that interferes with the integrity of this feature or the experience of other users." },
      ],
    },
    {
      heading: "7. Acceptable Use",
      blocks: [
        { type: 'paragraph', text: "You agree not to:" },
        {
          type: 'list', items: [
            "Use the Services for any unlawful purpose or in violation of any applicable law",
            "Reverse engineer, decompile, or attempt to extract the source code of any game, except where permitted by law",
            "Interfere with or disrupt the integrity or performance of the Services",
            "Use automated means (bots, scrapers) to access the Services without our prior written consent",
            "Harass, abuse, or harm other users in any community spaces we operate or participate in",
          ],
        },
      ],
    },
    {
      heading: "8. Intellectual Property",
      blocks: [
        { type: 'paragraph', text: "All content in our Services — including but not limited to game code, artwork, music, character designs, logos, and the mutopi, Ruanica, and Grimtile names and marks — is owned by mutopi or its licensors and is protected by copyright, trademark, and other intellectual property laws. Except as expressly permitted by these Terms, you may not copy, modify, distribute, sell, or lease any part of our Services." },
      ],
    },
    {
      heading: "9. User Feedback",
      blocks: [
        { type: 'paragraph', text: "If you submit feedback, ideas, or suggestions about our games (through our feedback form, community channels, or otherwise), you grant mutopi a perpetual, worldwide, royalty-free license to use that feedback for any purpose, without any obligation to compensate or credit you." },
      ],
    },
    {
      heading: "10. Suspension and Termination",
      blocks: [
        { type: 'paragraph', text: "We may suspend or terminate your access to any Service, at our discretion, if we believe you have violated these Terms — including the fair-play requirement in Section 6 — or if we discontinue a Service entirely. Where practical, we will provide notice, but we are not obligated to do so." },
      ],
    },
    {
      heading: "11. Disclaimers",
      blocks: [
        { type: 'paragraph', text: 'THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. GAMES UNDER DEVELOPMENT OR IN BETA (SUCH AS RUANICA) MAY CONTAIN BUGS, INCOMPLETE FEATURES, OR CHANGE SIGNIFICANTLY BEFORE RELEASE.' },
      ],
    },
    {
      heading: "12. Limitation of Liability",
      blocks: [
        { type: 'paragraph', text: "TO THE MAXIMUM EXTENT PERMITTED BY LAW, MUTOPI SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES." },
      ],
    },
    {
      heading: "13. Changes to These Terms",
      blocks: [
        { type: 'paragraph', text: 'We may update these Terms from time to time. If we make material changes, we will update the "Last updated" date above and, where appropriate, provide additional notice. Continued use of the Services after changes become effective constitutes acceptance of the revised Terms.' },
      ],
    },
    {
      heading: "14. Contact Us",
      blocks: [
        { type: 'paragraph', text: "If you have questions about these Terms, contact us at info@mutopi.com." },
      ],
    },
  ],
}
